function raise() {
  if (this.nextSibling) this.parentNode.appendChild(this);
}

export default function() {
  return this.each(raise);
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-selection/src/selection/raise.js
// module id = 246
// module chunks = 0